import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";

export interface ConfirmDeleteFileDialogData {
  filename: string;
}

/**
 * Confirmation dialog shown before removing an uploaded file attachment.
 * Returns true when the user confirms, false/undefined on cancel.
 */
@Component({
  selector: "lib-confirm-delete-file-dialog",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButton],
  template: `
    <h2 mat-dialog-title>Remove file</h2>
    <mat-dialog-content>
      <p>
        Remove <strong>{{ data.filename }}</strong
        >?
      </p>
      <p class="mat-font-body-sm mat-text-on-surface-variant">The uploaded file reference will be deleted.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Cancel</button>
      <button mat-flat-button color="warn" [mat-dialog-close]="true">Remove</button>
    </mat-dialog-actions>
  `,
})
export class ConfirmDeleteFileDialogComponent {
  protected readonly data = inject<ConfirmDeleteFileDialogData>(MAT_DIALOG_DATA);
}
